export enum WORD_TYPES {
  TERM = "TERM",
  CHARACTER = "CHARACTER",
  ERA = "ERA",
  PLACE = "PLACE",
  TRIBE = "TRIBE",
}
